import React from 'react';
import PropTypes from 'prop-types';
import AnalyticsHandler from '../../../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../../../Utils/AnalyticsHandler/AnalyticsEventNames';

function linkCell({ cell: { value: initialValue }, row: { original }, linkAccessor }) {
  return (
    <AnalyticsHandler eventName={AnalyticsEventNames.DOWNLOAD_INVOICE}>
      <a href={original[linkAccessor]} target="_blank">
        {initialValue}
      </a>
    </AnalyticsHandler>
  );
}

linkCell.propTypes = {
  cell: PropTypes.object,
  row: PropTypes.object,
  linkAccessor: PropTypes.string,
};

export default linkCell;
